import { ModelCategory, TrussGroup } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';

const trussGroupSchema = new ModelSchema<TrussGroup>('trussGroup', {
  category: ModelCategory.IntermediateModel,

  displayName: (trussGroup) => trussGroup.name,
  properties: {},
});

trussGroupSchema.children = { trussGroups: trussGroupSchema };

export const TrussGroupSchema = trussGroupSchema;
